<template>
  <FieldMultiSelect
    :label="label"
    :state="state"
    :disabled="disabled"
    :is-required="isRequired"
    :class-label="classLabel"
    :class-wrapper="classWrapper"
    :placeholder="placeholder"
    :emit-value="true"

    option-value="id"
    option-label="name"
    v-model="selected"

    :use-input="true"
    :allow-add-options="false"
    :load-options="loadOptions"
  />
</template>

<script>
import api from '@/aws/api'
import FieldMultiSelect from '@/components/forms/FieldMultiSelect'

export default {
  components: {
    FieldMultiSelect
  },

  props: {
    value: {},

    state: {
      type: Object
    },

    label: {
      type: String
    },

    isRequired: {
      type: Boolean
    },

    disabled: {
      type: Boolean,
      default: false
    },

    classLabel: {
      type: String
    },

    classWrapper: {
      type: String
    }
  },

  data () {
    const vm = this
    const isString = typeof vm.value === 'string'
    const isNumber = typeof vm.value === 'number'

    let selected = []
    let loadAfter = isString || isNumber ? String(vm.value).trim().split(',').filter(v => v.trim()) : []

    if (loadAfter.length) {
      loadAfter = loadAfter.join(',')
    } else {
      selected = toSelected(this.value)
    }

    return {
      selected,
      loadAfter
    }
  },

  mounted () {
    const vm = this
    vm.startLoadAfter()
  },

  computed: {
    placeholder () {
      const hasValue = Array.isArray(this.selected) && this.selected.length
      return hasValue ? '' : 'Selecionar'
    }
  },

  methods: {
    startLoadAfter () {
      const vm = this
      if (!vm.loadAfter.length) return

      api.getDocuments({ id: vm.loadAfter, limit: 999999 }).then(({ rows }) => {
        const selected = rows.map((row) => ({ id: row.id, name: row.description }))
        if (isEqual(vm.selected, selected)) return
        vm.selected = selected
      })
    },

    loadOptions (val) {
      return api.getDocuments({ $: val, limit: 30 }).then(({ rows }) => (
        rows.map((row) => ({ id: row.id, name: row.description }))
      ))
    }
  },

  watch: {
    selected (selected) {
      if (isEqual(selected, this.value)) return
      this.$emit('input', toSelected(selected))
    },

    value: {
      deep: true,
      handler (value) {
        const vm = this
        const isString = typeof value === 'string'
        const isNumber = typeof value === 'number'
        const loadAfter = isString || isNumber ? String(vm.value).trim().split(',').filter(v => v.trim()) : []

        if (loadAfter.length) {
          vm.loadAfter = loadAfter.join(',')
          vm.startLoadAfter()
        } else {
          if (isEqual(this.selected, value)) return
          this.selected = toSelected(value)
        }
      }
    }
  }
}

const toSelected = (val) => {
  if (Array.isArray(val)) return [...val]
  return val ? [val] : null
}

const isEqual = (val1, val2) => JSON.stringify(val1) === JSON.stringify(val2)
</script>
